export const DEFAULT_STEP_ORDER = {
  dataElements: [
    { id: 'description', order: 0 },
    { id: 'addButton', order: 1 },
    { id: 'searchInput', order: 2 },
    { id: 'dataElementsTable', order: 3 },
    { id: 'specialElementsTable', order: 4 },
    { id: 'lawfulBasisDropdown', order: 5 },
    { id: 'dataSourcesAccordion', order: 6 }
  ],
  stepMenu: [
    {
      id: 'processDetails',
      order: 0
    },
    {
      id: 'dataElements',
      order: 1
    },
    {
      id: 'dataSubjects',
      order: 2
    },
    {
      id: 'dataRetention',
      order: 3
    },
    {
      id: 'safeguards',
      order: 4
    },
    {
      id: 'transfers',
      order: 5
    }
  ],
  overallRisk: [
    {
      id: 'riskStepper',
      order: 0
    },
    {
      id: 'likelinesStepper',
      order: 1
    },
    {
      id: 'remediation',
      order: 2
    },
    {
      id: 'additionalComments',
      order: 3
    },
    {
      id: 'markAsReviewed',
      order: 4
    }
  ],
  stepRiskMenu: [
    {
      id: 'individualRisk',
      order: 0
    },
    {
      id: 'overallRisk',
      order: 1
    }
  ],
  processDetails: [
    {
      id: 'name',
      order: 0
    },
    {
      id: 'description',
      order: 1
    },
    {
      id: 'processGroups',
      order: 2
    },
    {
      id: 'automatedProcessing',
      order: 3
    },
    {
      id: 'automatedProcessingDescription',
      order: 4
    },
    {
      id: 'purpose',
      order: 5
    },
    {
      id: 'lawfulBasis',
      order: 6
    },
    {
      id: 'roleDetails',
      order: 7
    }
  ],
  transfers: [
    {
      id: 'thirdParty',
      order: 0
    },
    {
      id: 'crossBorder',
      order: 1
    }
  ],
  safeguards: [
    {
      id: 'safeguards',
      order: 0
    }
  ],
  dataRetention: [
    {
      id: 'description',
      order: 0
    },
    {
      id: 'retentionPolicies',
      order: 1
    }
  ],
  dataSubjects: [
    {
      id: 'dataSubjects',
      order: 0
    },
    {
      id: 'specialDataSubject',
      order: 1
    },
    {
      id: 'specialDataSubjects',
      order: 2
    },
    {
      id: 'legalBasis',
      order: 3
    }
  ]
}

export enum PROCESS_DETAILS_FIELDS {
  name = 'name',
  description = 'description',
  processGroups = 'processGroups',
  automatedProcessing = 'automatedProcessing',
  automatedProcessingDescription = 'automatedProcessingDescription',
  purpose = 'purpose',
  lawfulBasis = 'lawfulBasis',
  roleDetails = 'roleDetails'
}

export const NON_DELETABLE_PROCESS_DETAILS_FIELDS = [
  PROCESS_DETAILS_FIELDS.name,
  PROCESS_DETAILS_FIELDS.description,
  PROCESS_DETAILS_FIELDS.processGroups
]
